export default __webpack_public_path__ + "static/summer_containers2-4097bca89ff20549efd6517c777c625c.webp";